export default __webpack_public_path__ + "static/media/logo.be583a0d.jpg";